/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrSummaryRowRoot } from './igr-summary-row-root';
import { SummaryRowRoot } from './SummaryRowRoot';
import { TypeRegistrar } from "igniteui-react-core";
var IgrSummaryRowRootModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrSummaryRowRootModule() {
    }
    IgrSummaryRowRootModule.register = function () {
        TypeRegistrar.registerCons("IgrSummaryRowRoot", IgrSummaryRowRoot);
        TypeRegistrar.register("SummaryRowRoot", SummaryRowRoot.$type);
    };
    return IgrSummaryRowRootModule;
}());
export { IgrSummaryRowRootModule };
//# sourceMappingURL=igr-summary-row-root-module.js.map
